import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { PipesModule } from '@se-po/shared-data-access-pipes'
import { SharedUiPersonaAvatarModule } from '@se-po/shared-ui-persona-avatar'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { ParentContactInfoComponent } from './parent-contact-info/parent-contact-info.component'


@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    SeFeCardModule,
    SeFeChipModule,
    SeFeTranslationsModule,
    SharedUiPersonaAvatarModule

  ],
  declarations: [
    ParentContactInfoComponent
  ],
  exports: [
    ParentContactInfoComponent
  ],
})
export class SharedUiParentContactInfoModule {}
